(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["credits-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('credits-bar-component')) {
    customElements.define(
      'credits-bar-component',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelector('[data-close-credits]').addEventListener('click', () => {
            this.hidden = true;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    const tab_buttons = [...document.querySelectorAll('[data-tab]')];
  const tab_content = [...document.querySelectorAll('[data-tab-content]')];

  tab_buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const { currentTarget } = e;
      const id = button.dataset.tab;
      const container = currentTarget.closest('.tab__header-container');
      container.classList.add('active');
      tab_content.forEach((element) => {
        if (element.dataset.tabContent == id) {
          element.classList.remove('hidden');
        } else {
          element.classList.add('hidden');
        }
      });
      tab_buttons.forEach((element) => {
        const element_id = element.dataset.tab;
        if (element_id !== id) {
          const container = element.closest('.tab__header-container');
          container.classList.remove('active');
        }
      });
    });
  });

  tab_buttons[0].click();
  } catch(e) { console.error(e); }
})();

})();
